var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAjinomoto(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 500 500",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      stroke: "#000",
      fill: "#eaeaea",
      paintOrder: "fill",
      strokeWidth: 0
    },
    cx: 250,
    cy: 250,
    r: 250
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M452.2 223.6a35.5 35.5 0 0 0-35.1-32.2 37.4 37.4 0 0 0-36.4 23.9c0-9.3-3.2-16.7-11.7-19.8a39 39 0 0 0 18.2-32.8 39.5 39.5 0 0 0-39.8-39.1c-20.3 0-37 15-39.5 34.2v-15.9c0-13-7.6-22.9-23.4-22.9h-27c-8.1 0-15.5 3.8-20.5 9.7l-59.6 68.4c-7.6-2-24.4-5.6-38.2-5.7-24-.1-46 9-63.2 26.5a56.8 56.8 0 0 0-11.7 62c8.8 19.2 27.4 31.9 53.4 32.6 38.9 1.1 63.5-25.5 85-49.7 13.3 3.2 26 5 41.2 5.6V289c0 12 10 21.9 22.3 21.9h31.3c-11.4 7.5-16.4 16.7-17 25.4-.8 11 10.4 32.7 45 32.7 14.7 0 28.2-6.1 38-17.3 8-9.3 13-21.3 14.3-35a276.4 276.4 0 0 0 47.2-34.2c19.1-18.3 29-37.9 27.2-58.9Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m257.5 178-39.3 45.8c13.6 3.2 26.3 4.8 39.3 4.6Zm-95.6 57.5a60.4 60.4 0 0 0-15.3-3.8c-16.5-2.3-32.2 0-43 14.8-8 11-3.8 28.6 9.6 28.6 12.6 0 24.8-14.8 35.2-25.7ZM364.7 309c-.1 28.4-17.7 46.6-39.1 46.6-9.8 0-18.7-2.1-25.6-8-6.6-5.6-10.5-14 3.8-24l26-17.5.1-71.8c-12.4 6.7-24 11.3-36.6 15V289c0 4.7-4 8.6-8.8 8.6h-18.3a8.7 8.7 0 0 1-8.7-8.6v-33.7c-25.1 0-41.5-2.4-59.7-7.7v.1s-6.3 7.6-12.9 14.6c-24.7 26.5-41.4 36.9-67.2 36.9-39.4 0-59.6-41.7-31.6-72.4a72.5 72.5 0 0 1 61.3-21.7c15.3 1.5 27.5 5 34.5 7.4l65.7-75.4c3-3.1 6-4.7 9.8-4.7h27.1c4.7 0 8.5 3.6 8.8 8.2v82.2c21.7-7.5 33-17.7 44.6-17.7h17.6c5 0 9.1 3.9 9.2 8.7V283c18.4-13 33-25.6 39.2-39.9-5.1-3.8-8.4-10-8.4-16.8 0-11.7 9.6-21.2 21.6-21.2 11.3 0 21.7 9.2 21.7 21.3 1.8 34.7-39.2 61.8-74.1 82.7ZM321 162.7a26 26 0 0 1 26.3-25.8 26 26 0 0 1 26.2 25.8 26 26 0 0 1-26.2 25.8 26 26 0 0 1-26.3-25.8Z",
    fill: "#E31118"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAjinomoto);
export default __webpack_public_path__ + "static/media/ajinomoto.8f173082.svg";
export { ForwardRef as ReactComponent };